// extracted by mini-css-extract-plugin
export default {"List":"banners-list_List__P6+iI","ListElement":"banners-list_ListElement__0i--h"};